import { FC } from 'react';
import './IVDetails.scss';
import emptyAvarter from './../../../../../Assets/images/user-empty-avatar.png';
import policelogo from './../../../../../Assets/images/logo.png';
import psclogo from './../../../../../Assets/images/psc1_logo.png';

interface propsType {
  value: any;
  disable: boolean;
}

const IVDetails: FC<propsType> = ({ value, disable }) => {
  const {
    surname,
    firstname,
    middlename,
    nin,
    photo,
    jobYear,
    gender,
    dob,
    stateOfPermanent,
    lgaOfPermanent,
    phone,
    email,
    authQR,
    aptitude,
  } = value;
  // console.log('workflow', value);
  const emailDisplay = Array.isArray(email) ? email[0] : email;
  const isInvited =
    aptitude?.metadata && aptitude.metadata.isQualified === true;
  const isNotInvited =
    aptitude?.metadata && aptitude.metadata.isQualified === false;
  // console.log('workflow', isInvited, isNotInvited, aptitude);
  const schedule = aptitude?.scheduleSchema || {};

  return (
    <div className='iv-details my-3'>
      {disable && (
        <div className='container-fluid'>
          <div className='row d-flex justify-content-center'>
            <div className='col-12'>
              <div className='iv-slip'>
                {/* Header */}
                <div className='iv-header'>
                  <img src={policelogo} alt='police' className='iv-logo' />
                  <div className='iv-title-block'>
                    <p className='iv-main-title'>
                      RECRUITMENT OF POLICE CONSTABLES
                    </p>
                    <p className='iv-main-title'>
                      INTO THE NIGERIA POLICE FORCE
                    </p>
                    <p className='iv-year'>({jobYear || '2025/2026'})</p>
                    {isInvited && (
                      <p className='iv-label'>INVITATION TO EXAMINATION</p>
                    )}
                  </div>
                  <img src={psclogo} alt='psc' className='iv-logo' />
                </div>

                <div className='iv-divider' />

                {/* Profile always visible */}
                <div className='iv-content-layout'>
                  <div className='iv-fields-col'>
                    <div className='iv-section-heading'>
                      Personal Information
                    </div>

                    <div className='iv-label-row'>Name:</div>
                    <div className='iv-name-row'>
                      <div className='iv-name-col'>
                        <div className='iv-sublabel'>Surname</div>
                        <div className='iv-cell'>
                          {surname?.toUpperCase() || ''}
                        </div>
                      </div>
                      <div className='iv-name-col'>
                        <div className='iv-sublabel'>First Name</div>
                        <div className='iv-cell'>
                          {firstname?.toUpperCase() || ''}
                        </div>
                      </div>
                      <div className='iv-name-col'>
                        <div className='iv-sublabel'>Other Name</div>
                        <div className='iv-cell'>
                          {middlename?.toUpperCase() || ''}
                        </div>
                      </div>
                    </div>

                    <div className='iv-two-col-row'>
                      <div className='iv-field-item'>
                        <span className='iv-field-label'>Date of Birth:</span>
                        <div className='iv-cell'>{dob || ''}</div>
                      </div>
                      <div className='iv-field-item'>
                        <span className='iv-field-label'>Gender:</span>
                        <div className='iv-cell'>
                          {gender?.toUpperCase() || ''}
                        </div>
                      </div>
                    </div>

                    <div className='iv-two-col-row'>
                      <div className='iv-field-item'>
                        <span className='iv-field-label'>State of Origin:</span>
                        <div className='iv-cell'>{stateOfPermanent || ''}</div>
                      </div>
                      <div className='iv-field-item'>
                        <span className='iv-field-label'>LGA:</span>
                        <div className='iv-cell'>{lgaOfPermanent || ''}</div>
                      </div>
                    </div>

                    <div className='iv-two-col-row'>
                      <div className='iv-field-item'>
                        <span className='iv-field-label'>NIN:</span>
                        <div className='iv-cell'>{nin || ''}</div>
                      </div>
                      <div className='iv-field-item'>
                        <span className='iv-field-label'>Phone No.:</span>
                        <div className='iv-cell'>{phone || ''}</div>
                      </div>
                    </div>

                    <div className='iv-full-row'>
                      <div className='iv-field-item'>
                        <span className='iv-field-label'>Email Address:</span>
                        <div className='iv-cell'>{emailDisplay || ''}</div>
                      </div>
                    </div>
                  </div>

                  {/* Right: passport photo */}
                  <div className='iv-photo-col'>
                    <div className='iv-section-heading'>Candidate Photo</div>
                    {photo
                      ? <img
                        src={`${photo}`}
                        alt='passport'
                        className='iv-photo'
                      />
                      : <img
                        src={emptyAvarter}
                        alt='passport'
                        className='iv-photo'
                      />
                    }
                    {isInvited && (
                      <div className='iv-status-badge invited'>INVITED</div>
                    )}
                    {isNotInvited && (
                      <div className='iv-status-badge not-invited'>
                        NOT INVITED
                      </div>
                    )}
                  </div>
                </div>

                {/* Bottom section: exam info or disqualification */}
                {isInvited && (
                  <div className='iv-exam-info-section'>
                    <div className='iv-section-heading iv-section-heading--exam'>
                      Candidate Exam Information
                    </div>
                    <table className='iv-schedule-table iv-schedule-table--full'>
                      <tbody>
                        <tr>
                          <td>Venue</td>
                          <td>{schedule['cbt-venue'] || 'N/A'}</td>
                        </tr>
                        <tr>
                          <td>Date</td>
                          <td>{schedule['cbt-date'] || 'N/A'}</td>
                        </tr>
                        <tr>
                          <td>Time</td>
                          <td>{schedule['cbt-time'] || 'N/A'}</td>
                        </tr>
                        <tr>
                          <td>Seat No.</td>
                          <td>{schedule['seat-no'] || 'N/A'}</td>
                        </tr>
                      </tbody>
                    </table>
                    {isInvited && authQR && (
                      <div className='iv-qr-row'>
                        <img
                          src={`data:image/png;base64,${authQR}`}
                          alt='auth qr'
                          className='iv-qr'
                        />
                      </div>
                    )}
                  </div>
                )}

                {isNotInvited && (
                  <div className='iv-result-notice iv-result-notice--fail'>
                    <div className='iv-result-notice__heading'>
                      RESULT NOTIFICATION
                    </div>
                    <div className='iv-result-notice__body'>
                      <p className='iv-result-notice__salutation'>
                        Dear {surname?.toUpperCase()} {firstname?.toUpperCase()}
                        ,
                      </p>
                      <p className='iv-result-notice__text'>
                        Be informed that following the credential and physical
                        screening assessment conducted earlier, you did not meet
                        the minimum benchmark required for further consideration
                        in the <strong>{jobYear || '2025'} Recruitment Exercise</strong>.
                      </p>
                      {aptitude?.metadata.remark && (
                        <div className='iv-result-notice__remark'>
                          <span className='iv-result-notice__remark-label'>
                            Reason(s):
                          </span>
                          {Array.isArray(aptitude?.metadata?.remark)
                            ? <ul>
                              {aptitude.metadata.remark.map(
                                (r: any, i: number) => (
                                  <li key={i}>
                                    {typeof r === 'object' && r !== null
                                      ? Object.values(r).join(', ')
                                      : r}
                                  </li>
                                ),
                              )}
                            </ul>
                            : typeof aptitude?.metadata?.remark === 'object' && aptitude.metadata.remark !== null
                              ? <ul>{Object.values(aptitude.metadata.remark).map((v: any, i: number) => <li key={i}>{String(v)}</li>)}</ul>
                              : <p>{aptitude.metadata.remark}</p>}
                        </div>
                      )}
                      <p className='iv-result-notice__text'>
                        As a result, your participation in the current
                        recruitment process ends with effect from this notice.
                        The Police Service Commission maintains strict adherence
                        to merit-based quotas and performance standards.

                      </p>
                      <p>
                        <strong>The Commission thanks you for your interest in serving the nation.</strong>
                      </p>
                    </div>
                  </div>
                )}

                {isInvited && (
                  <div className='iv-colour-warning'>
                    THIS SLIP MUST BE PRINTED AND PRESENTED IN COLOUR (NOT BLACK
                    AND WHITE)
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {isInvited && (
        <div className='text-center iv-note'>
          <div>NOTE: This slip should be presented at the Examination venue.</div>
          <div>No admission into the examination hall without this slip.</div>
        </div>
      )}
    </div>
  );
};

export default IVDetails;
